import PropTypes from 'prop-types';
import classNames from 'classnames';
import ButtonLink from '@hiredigital/ui/Button/NextButtonLink';
import InteractiveButton from '@components/InteractiveButton/InteractiveButton';

import Styles from './Long.module.scss';

const content = {
  heading: 'Looking for {talentType}?',
  description:
    'Access top performing {talentType} and other experts with a track record of helping top companies develop a world-class customer experience. Connect with a Hire Digital Director to find the talent you need.',
  viewMoreButtonLabel: 'View More Profiles',
  images: [
    { url: `/img/Image_1.webp`, width: '160px', height: '160px' },
    { url: `/img/Image_2.webp`, width: '192px', height: '128px' },
    { url: `/img/Image_3.webp`, width: '160px', height: '240px' },
    { url: `/img/Image_4.webp`, width: '160px', height: '240px' },
    {
      url: `/img/Image_5.webp`,
      width: '192px',
      height: '128px',
    },
  ],
};

const LongCTA = ({ cta, analyticsData }) => {
  return (
    // Container
    <div className={Styles.gridContainer}>
      <div className={Styles.gridItem}>
        {/* Heading */}
        <div className={Styles.heading}>
          {cta?.heading ||
            `No long-term contracts.
             No catches.`}
        </div>
        {/* Description */}
        <div className={Styles.description}>
          {cta?.description || `Start hiring talents on demand now.`}
        </div>
        {/* Images */}

        {/* View More Button */}
        <div className={Styles.buttons}>
          <InteractiveButton
            type={
              InteractiveButton.Type[
                // `=== false` is used to coerce `undefined` to `true`
                cta?.button2isPrimary === false ? 'BLUE' : 'WHITE_BLUE_OUTLINE'
              ]
            }
            size={ButtonLink.Size.LARGE}
            className={Styles.button}
            href={{
              pathname: cta?.button1?.url || `/why`,
              query: { ...analyticsData },
            }}>
            {cta?.button1?.label || 'Learn How'}
          </InteractiveButton>
          <InteractiveButton
            type={
              InteractiveButton.Type[
                // `=== false` is used to coerce `undefined` to `true`
                cta?.button2isPrimary === false ? 'WHITE_BLUE_OUTLINE' : 'BLUE'
              ]
            }
            size={ButtonLink.Size.LARGE}
            className={Styles.button}
            href={{
              pathname: cta?.button2?.url || `/get-started`,
              query: { ...analyticsData },
            }}>
            {cta?.button2?.label || 'Get Started'}
          </InteractiveButton>
        </div>
      </div>
      <div className={Styles.gridItem}>
        <div className={Styles.imagesContainer}>
          {content.images.map(({ url, ...image }, index) => (
            <div key={index} className={Styles.image} style={image}>
              <img src={url} alt={`${index}`} loading='lazy' />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LongCTA;
